// reservationStatusTexts.tsx
import React from "react";
import styled from "styled-components";

/* ---------- Drop-in bold that always shows bolder ---------- */
export const Strong = styled.span`
  font-weight: bold !important; /* force heavy */
  font-variation-settings: "wght" 900; /* for variable fonts */
  font-synthesis-weight: none; /* avoid fake bold */
`;

/* ---------- Status groups (unchanged) ---------- */
export const cancelledStatuses = [
  "cancelled_customer",
  "cancelled_restaurant",
  "Cancelled",
];

export const cancelledDidNotAttendStatuses = [
  "cancelled_customer",
  "cancelled_restaurant",
  "Cancelled",
  "no_show",
];

export const acceptedStatuses = ["accepted", "late", "waiting_list"];

export const pendingStatuses = ["pending_customer", "pending_restaurant"];

/* ---------- Abbreviation (unchanged) ---------- */
export function getReservationStatusAbreviationTranslation(status) {
  switch (status) {
    case "past_estimated_time":
      return <>Libertar mesa?</>;
    case "accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return <>Confirmada</>;

    case "pending_customer":
      return <>Aguarda reconfirmação do cliente</>;

    case "pending_restaurant":
      return <>Aguarda aceitação do restaurante</>;

    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <>Na lista de espera</>;

    case "waiting_list":
      return <>Na fila à porta</>;

    case "edited":
      return <>Alteração por aceitar</>;
    case "Accepted_edit":
      return <>Alteração aceite</>;
    case "Rejected_edition":
      return <>Alteração recusada</>;

    case "late":
      return <>Atrasada</>;

    case "attended":
      return <>Mesa ocupada</>;
    case "completed":
      return <>Mesa livre</>;

    case "no_show":
      return <>Não compareceu</>;

    case "cancelled_customer":
    case "Cancelled":
      return <>Cancelada cliente</>;
    case "cancelled_restaurant":
    case "Rejected":
      return <>Cancelada restaurante</>;

    default:
      return <>Null</>;
  }
}

/* ---------- Tooltip (restaurant) with <Strong> ---------- */
export function getReservationStatusTooltipTranslationForRestaurant(status) {
  switch (status) {
    case "past_estimated_time":
      return <>Libertar mesa?</>;
    case "accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return (
        <>
          <Strong>Reserva confirmada.</Strong>
          <br />
          <br />
          Aguardar chegada dos clientes.
        </>
      );

    case "pending_restaurant":
      return <>O restaurante deve aceitar ou recusar a reserva.</>;

    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <></>;

    case "edited":
      return <>O restaurante deve aceitar ou recusar a edição à reserva.</>;
    case "Edited_accept":
      return (
        <>
          O restaurante deve aceitar ou recusar a edição à reserva.
          <br />
          <br />
          <Strong>Atenção:</Strong> a edição será aceite e a reserva ficará
          <Strong> confirmada</Strong> ou a aguardar reconfirmação do cliente.
          <br />
        </>
      );
    case "Edited_reject":
      return (
        <>
          O restaurante deve aceitar ou recusar a edição à reserva.
          <br />
          <Strong>Atenção:</Strong> a edição será aceite e a reserva ficará
          <Strong> confirmada</Strong> ou a aguardar reconfirmação do cliente.
          <br />
        </>
      );

    case "Accepted_edit":
      return (
        <>
          <Strong>Atenção:</Strong> a edição será aceite e a reserva ficará
          <Strong> confirmada</Strong> ou a aguardar reconfirmação do cliente.
          <br />
          Se a reserva estava{" "}
          <Strong>a aguardar aceitação do restaurante</Strong>, ficará
          definitivamente <Strong>recusada</Strong>.
          <br />
          Se a reserva estava{" "}
          <Strong>confirmada ou a aguardar reconfirmação do cliente</Strong>:
          continuará no estado em que estava, mas sem a edição solicitada.
        </>
      );

    case "Rejected_edition":
      return <>Nota descritiva do estado respetivo</>;

    case "late":
      return <>Já passa da hora marcada.</>;

    case "waiting_list":
      return <>Na fila à porta</>;

    case "cancelled_customer":
    case "Cancelled":
      return (
        <>
          Reserva cancelada por: <Strong>Cliente</Strong>
          <br />
        </>
      );

    case "cancelled_restaurant":
      return <>Reserva recusada pelo restaurante</>;

    case "attended":
      return <>Refeição em curso.</>;

    case "completed":
      return <>Refeição concluída.</>;

    case "no_show":
      return <>A reserva não se concretizou.</>;

    default:
      return <></>;
  }
}

export function getReservationStatusTranslationClient(status) {
  switch (status) {
    // ✅ Reserva confirmada
    case "accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return <>Reserva confirmada 🟢</>;

    // 🟡 Pendente do restaurante
    case "pending_restaurant":
      return <>Reserva pendente de confirmação do restaurante 🟡</>;

    // 🟡 Alteração pendente
    case "edited":
      return <>Pedido de alteração pendente de confirmação 🟡</>;

    // 🟢 Alteração aceite
    case "Accepted_edit":

    // 🔴 Alteração recusada
    case "Rejected_edition":

    // 🟠 Atraso
    case "late":
      return <>Estás atrasado/a 🟠</>;

    // 🟡 Fila / lista de espera
    case "waiting_list":
    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <>Avisamos quando tivermos mesa disponível 🟡</>;

    // 🟢 Mesa pronta
    case "table_ready":
      return <>A tua mesa está pronta 🟢</>;

    // 🟢 Estado genérico (se usares isto noutros sítios)
    case "attended":
      return <>Reserva confirmada 🟢</>;

    // 🟢 Finalizada
    case "completed":
      return <>Reserva confirmada 🟢</>;

    // ❌ No-show
    case "no_show":
      return <>Falta de comparência ❌</>;

    // 🔴 Cancelada pelo cliente
    case "cancelled_customer":
    case "Cancelled":
      return <>Cancelaste a tua reserva 🔴</>;

    // 🔴 Cancelada/recusada pelo restaurante
    case "cancelled_restaurant":
    case "Rejected":
      return <>A tua reserva foi cancelada pelo restaurante 🔴</>;

    default:
      return <>Estado desconhecido</>;
  }
}

/* ---------- Colors (unchanged) ---------- */
export function getReservationStatusColors(status) {
  switch (status) {
    case "pending_customer":
    case "pending_restaurant":
    case "edited":
    case "late":
    case "waiting_list":

    case "accepted":
    case "attended":
      return "#4CAE4C";

    case "no_show":
    case "cancelled_customer":
    case "Cancelled":
    case "cancelled_restaurant":
      return "#D94B4B";

    default:
      return "Null";
  }
}
